var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDropdownArrBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 6,
    viewBox: "0 0 7 6",
    fill: "#000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.563 4.815L.034.79C-.117.55-.044.23.197.08.279.026.374 0 .47 0H5.53c.285 0 .516.231.516.516 0 .097-.028.192-.08.274L3.438 4.815c-.152.24-.47.314-.711.162-.066-.041-.122-.097-.163-.162z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDropdownArrBlack);
export default __webpack_public_path__ + "static/media/ic-dropdown-arr-black.dbd30a6fb18d2e018d537c3c4c0587c2.svg";
export { ForwardRef as ReactComponent };